import { Container, Row, Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";

const Usedvehicleintegrate = () => {
  return (
    <>
      <Container>
        <div className="screenHeight">
          <Shopintegrate
            newshop="/used-vehicle"
            url="/usedvehicle-integrate-form"
          />
        </div>
      </Container>
    </>
  );
};

export default Usedvehicleintegrate;
